<app-header *ngIf="showHeader"></app-header>
<router-outlet></router-outlet>
<app-whatsapp-button *ngIf="showWhatsapp"></app-whatsapp-button>

<button
  type="button"
  class="back-to-top"
  *ngIf="showBackToTop"
  (click)="scrollToTop()"
  aria-label="العودة للأعلى"
>
  <i class="fa-solid fa-arrow-up"></i>
</button>

<app-footer *ngIf="showFooter"></app-footer>

<!-- loader -->
<ngx-ui-loader></ngx-ui-loader>

<!-- toast -->
<p-toast position="top-center" key="tc" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="flex w-full p-1">
            <mat-icon style="width: 30px; height: 24px; font-size: 24px;">{{message.icon}}</mat-icon>
            <div class="px-2 w-full">
                <!-- <h4>{{message.summary}}</h4> -->
                <p class="m-0">{{message.detail}}</p>
            </div>
        </div>
    </ng-template>
</p-toast>
